import React from "react";
import { DailyValues } from "../../modification/model";
import { AmountRender } from "./AmountRender";
import { compareAsc, format, parseISO } from "date-fns";

export function DailyPricesRender(props: DailyValues) {
  const dailyValues = Object.entries(props).map(it => it);
  dailyValues.sort((a, b) => compareAsc(parseISO(a[0]), parseISO(b[0])));

  return (
    <>
      {dailyValues.map(([date, value], index) => {
        return (
          <div key={index}>
            {date}: <AmountRender key={index} amount={value.amount} />
          </div>
        );
      })}
    </>
  );
}
